import { Avatar } from "@/components/buttons/Avatar";
import { GetGroup } from "@/store/services/supabase";
import { Select } from "antd";
interface UserOption {
  id: string | null;
  email: string | null;
}
interface UserGroupFilterProps {
  users: UserOption[];
  groups: GetGroup[];
  selectedUserId: string;
  selectedGroupId: string;
  onUserChange: (id: string) => void;
  onGroupChange: (id: string) => void;
}
export const UserGroupFilter = ({
  users,
  groups,
  selectedUserId,
  selectedGroupId,
  onUserChange,
  onGroupChange
}: UserGroupFilterProps) => <div className="flex items-center justify-start gap-2" data-sentry-component="UserGroupFilter" data-sentry-source-file="UserGroupFilter.tsx">
    <Select className="w-max" placeholder="All users" onChange={onUserChange} popupMatchSelectWidth={false} defaultValue="" value={selectedUserId} options={[{
    value: "",
    label: "All users"
  }, ...users.filter(u => u.id != null).map(u => ({
    value: u.id as string,
    label: <div className="flex items-center gap-2">
              <div>
                <Avatar name={u.email ?? ""} size={16} />
              </div>
              <span>{u.email}</span>
            </div>
  }))]} data-sentry-element="Select" data-sentry-source-file="UserGroupFilter.tsx" />
    <Select className="w-max" placeholder="All groups" onChange={onGroupChange} popupMatchSelectWidth={false} defaultValue="" value={selectedGroupId} options={[{
    value: "",
    label: "All groups"
  }, ...groups.map(g => ({
    value: g.id,
    label: <div className="flex items-center gap-2">
              <span>{g.name}</span>
            </div>
  }))]} data-sentry-element="Select" data-sentry-source-file="UserGroupFilter.tsx" />
  </div>;